import React from 'react'
import StatBoxes from './StatBoxes'

const Dashboard = () => {
  return (
    <>
      <StatBoxes />
    </>
  )
}

export default Dashboard